import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const ImageModal = ({ onDismiss, show }) => {
  const { t } = useTranslation();

  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title">{t('Image')}</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <p>
          {t(`Give your Reward or Clue an image. Click the thumbnail to upload a new
          image.`)}
        </p>
        <ul>
          <li>
            {t(`Reward and Clue images are displayed as thumbnails and fullscreen
            alongside the description.`)}
          </li>
          <li>
            {t(`The best images are optimized for display on the phone, square, and at
            least 800 by 800 pixels in size.`)}
          </li>
        </ul>
      </div>
      <div className="modal-footer">
        <Button color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t(`Close`)}
        </Button>
      </div>
    </Modal>
  )
};

export default ImageModal;
